import { render, staticRenderFns } from "./CartMenuIcon.vue?vue&type=template&id=5e0d4dbd&scoped=true"
import script from "./CartMenuIcon.vue?vue&type=script&lang=js"
export * from "./CartMenuIcon.vue?vue&type=script&lang=js"
import style0 from "./CartMenuIcon.vue?vue&type=style&index=0&id=5e0d4dbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d4dbd",
  null
  
)

export default component.exports